module.exports = __webpack_public_path__ + "img/signal-bars-good.ff2e77c3.svg";